import React from "react";
import { useTheme } from "@mui/material/styles";
import {
  getLabelStyle,
  getValueStyle,
} from "@features/port-security/components/security-clearance-request-preview/UserDetailsCard/UserDetailsCard.styles.tsx";
import type {
  FieldEntry,
  UserDetailsCardProps,
} from "@features/port-security/components/security-clearance-request-preview/UserDetailsCard/UserDetailsCard.types.ts";

const UserDetailsCard: React.FC<UserDetailsCardProps> = ({
  testId,
  leftFields = [],
  rightFields = [],
  columns = 2,
  lastItemBorder = true,
}) => {
  const theme = useTheme();

  const renderColumn = (fields: FieldEntry[]) => {
    return (
      <div className="flex flex-col space-y-0 w-full">
        {fields.map(({ label, value }, index) => {
          const isLast = index === fields.length - 1;
          const borderClass = !isLast || lastItemBorder ? "border-b" : "";

          return (
            <div
              key={`${label}-${index}`}
              className={`flex items-center py-3 ${borderClass}`}
              style={
                borderClass
                  ? { borderBottomColor: theme.palette.strokeColor?.secondary }
                  : undefined
              }
            >
              <span className="w-1/2 text-sm font-normal leading-none" style={getLabelStyle(theme)}>
                {label}
              </span>
              <span
                className="w-1/2 text-sm font-medium leading-none break-words break-all"
                style={getValueStyle(theme)}
              >
                {value || "-"}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const mergedFields = [...(leftFields ?? []), ...(rightFields ?? [])];

  return (
    <div
      data-testid={testId}
      className={`w-full flex gap-12 ${columns === 1 ? "flex-col" : "flex-col md:flex-row"} no-border`}
    >
      {columns === 1 ? (
        renderColumn(mergedFields)
      ) : (
        <>
          {renderColumn(leftFields ?? [])}
          {renderColumn(rightFields ?? [])}
        </>
      )}
    </div>
  );
};

export default UserDetailsCard;
